var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"openmini"},[_c('div',[_c('wx-open-launch-weapp',{attrs:{"id":"launch-btn","username":"gh_67fc2a203508","path":"pages/index"}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v("\n            <style>.btn { padding: 12px;background:green }</style>\n            <button class=\"btn\">打开小程序</button>\n        ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23ba8cee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhongzhuan.vue
// module id = null
// module chunks = 